﻿/* globals __DEBUG__ */
var jquery = require("jquery");

/*
* jQuery Tiny Pub/Sub
* https://github.com/cowboy/jquery-tiny-pubsub
*
* Copyright (c) 2013 "Cowboy" Ben Alman
* Licensed under the MIT license. 
*/

(function () {

    var o = window.__habPubSub = window.__habPubSub || jquery({});

    var consoleDebug = function (title, args) {
        if (__DEBUG__ === true) {
            var logText = "";
            logText = title + " Event:" + args[0];
            for (var i = 1; i < args.length; i++) {
                logText += " Arg" + i + ": " + args[i];
            }
            console.log(logText);
            console.log(o.data('events'));
        }
    };

    jquery.subscribe = function () {
        o.on.apply(o, arguments);
        consoleDebug("Subscribe", arguments);
    };

    jquery.unsubscribe = function () {
        o.off.apply(o, arguments);
        consoleDebug("Unsubscribe", arguments);
    };

    jquery.publish = function () {
        o.trigger.apply(o, arguments);
        consoleDebug("Publish", arguments);
    };

    jquery.getSubscribeEvents = function () {
        console.log(jquery._data(o, 'events'));
    };
}());